import React from 'react';
import styled from 'styled-components';
import kituLogo from 'assets/kitu-logo.svg';

const { REACT_APP_VERSION, REACT_APP_PRODUCT_NAME } = window.env;

export const FooterVersion = styled.footer`
  width: 100%;
  font-size: 12px;
  text-align: center;
  background-color: #cfd1d3;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  height: 40px;
`;

export const FooterImage = styled.img`
  width: ${({ width }) => width}
  height: ${({ height }) => height}
  margin-left: 12px;
`;

export const FooterText = styled.span`
  flex: 1;
`;

const Footer = () => {
  return (
    <FooterVersion>
      <FooterImage src={kituLogo} width="50px" height="30px" />
      <FooterText>
        {REACT_APP_PRODUCT_NAME} v{REACT_APP_VERSION}
      </FooterText>
    </FooterVersion>
  );
};

export default Footer;
